export const CONFIG = {
  apiKey: "AIzaSyAFrBXh2cC2ay2JSRiwK6QSzsRH6OPxSZ0",
  authDomain: "ticketshipper.firebaseapp.com",
  databaseURL: "https://ticketshipper-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "ticketshipper",
  storageBucket: "ticketshipper.appspot.com",
  messagingSenderId: "460657703876",
  appId: "1:460657703876:web:e1370cbe4f234428b60291",
  measurementId: "G-JBJC0WQ63N"
}